const KZ = {
  ibanLength: 20,
};
export { KZ };
